module.exports = __webpack_public_path__ + "static/img/day-6.d1317fa.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list/day-6.png
// module id = VGn1
// module chunks = 1